import React from 'react';
import logo from '../assets/image.png';

const Navigation: React.FC = () => {
    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <nav style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            zIndex: 1000,
            padding: '1rem 2rem'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: '#1a365d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                }}>
                    <img 
                        src={logo} 
                        alt="Orbit AI" 
                        style={{
                            height: '50px',
                            width: 'auto'
                        }}
                    />
                </div>
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    alignItems: 'center'
                }}>
                    <button onClick={() => scrollToSection('products')} style={{
                        cursor: 'pointer',
                        color: '#1a365d',
                        background: 'none',
                        border: 'none',
                        fontSize: '1rem',
                        fontWeight: '500',
                        transition: 'color 0.3s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#6366f1'}
                    onMouseOut={(e) => e.currentTarget.style.color = '#1a365d'}
                    >Products</button>
                    <button onClick={() => scrollToSection('governance-engine')} style={{
                        cursor: 'pointer',
                        color: '#1a365d',
                        background: 'none',
                        border: 'none',
                        fontSize: '1rem',
                        fontWeight: '500',
                        transition: 'color 0.3s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#6366f1'}
                    onMouseOut={(e) => e.currentTarget.style.color = '#1a365d'}
                    >Governance</button>
                    <button onClick={() => scrollToSection('chrome-extension')} style={{
                        cursor: 'pointer',
                        color: '#1a365d',
                        background: 'none',
                        border: 'none',
                        fontSize: '1rem',
                        fontWeight: '500',
                        transition: 'color 0.3s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#6366f1'}
                    onMouseOut={(e) => e.currentTarget.style.color = '#1a365d'}
                    >Extension</button>
                    <button onClick={() => scrollToSection('chrome-extension')} style={{
                        backgroundColor: '#6366f1',
                        color: 'white',
                        border: 'none',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        transition: 'all 0.3s',
                        boxShadow: '0 2px 8px rgba(99, 102, 241, 0.3)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#4f46e5';
                        e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#6366f1';
                        e.currentTarget.style.transform = 'scale(1)';
                    }}
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;
